module.exports = __webpack_public_path__ + "img/13.d08591cf.png";